export default {
  en: "English",
  de: "Deutsch"
}